import React from 'react';

import {TeamInformation} from 'containers/MyTeams/components/shared';
import ButtonDropdown from 'components/ButtonDropdown';
import VisibleIf from 'components/VisibleIf';
import {PERMISSIONS} from 'ducks/auth';

const TeamSection = ({
  team,
  openManageTeamPermissionsModal,
  openEditTeamModal,
  openManageLocationsModal,
  openDeleteTeamConfirmationModal,
  openSetInactivityLogoutModal
}) => (
  <div className="teamSection">
    <TeamInformation team={team} />
    <div className="dropdown">
      <ButtonDropdown
        title="Team Options"
        menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM}>
        <ButtonDropdown.Option
          onClick={() => openEditTeamModal({teamId: team.id})}>
          Edit Team Details
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          onClick={() => openManageTeamPermissionsModal({teamId: team.id})}>
          Manage Permissions
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          onClick={() => openManageLocationsModal({teamId: team.id})}>
          Manage Locations
        </ButtonDropdown.Option>
        <VisibleIf permission={PERMISSIONS.SET_TEAM_INACTIVITY_TIMER}>
          <ButtonDropdown.Option
            onClick={() => openSetInactivityLogoutModal({teamId: team.id})}>
            Set Inactivity Logout
          </ButtonDropdown.Option>
        </VisibleIf>
        <ButtonDropdown.Option
          className="deleteTeam"
          onClick={openDeleteTeamConfirmationModal}>
          Delete Team
        </ButtonDropdown.Option>
      </ButtonDropdown>
    </div>
  </div>
);

export default TeamSection;
